import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './setupAxios401'
import App from './App.jsx'
import './index.css'
import '../src/styles/global.css'
import { ThemeProvider } from '@emotion/react'
import theme from './styles/theme.js'

createRoot(document.getElementById('root')).render(
      <ThemeProvider theme={theme}>
      <App />
      </ThemeProvider>
)
